import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import IMenu from '@/js/components/molecules/IMenu.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListingSort',
  props: {
    params: null,
    sort: null,
    order: null
  },
  setup(__props: any) {

const props = __props as {
  params: string;
  sort: string;
  order: string;
};


const list = [
  {
    sort: 'popular',
    order: 'asc',
    text: '注目順',
  },
  {
    sort: 'listed',
    order: 'desc',
    text: '新着順',
  },
  {
    sort: 'pv',
    order: 'desc',
    text: '閲覧数順',
  },
  {
    sort: 'price',
    order: 'asc',
    text: '価格が安い順',
  },
  {
    sort: 'price',
    order: 'desc',
    text: '価格が高い順',
  },
];
const label = computed(() => list.find((item) => item.sort === props.sort && item.order === props.order)?.text || '');

return { __sfc: true,props, list, label, IMenu }
}

})